/*
 * Copyright (c) 2025.
 * The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */

import React from "react";
import clsx from "clsx";
import TableWrapper from "pages/Front/components/Tanstack/components/TableWrapper";
import TableHeadWrapper from "pages/Front/components/Tanstack/components/TableHeadWrapper";
import TableHeadRow from "pages/Front/components/Tanstack/components/TableHeadRow";
import TableHeadColumn from "pages/Front/components/Tanstack/components/TableHeadColumn";
import TableHeadColumnInnerWrapper from "pages/Front/components/Tanstack/components/TableHeadColumnInnerWrapper";
import TableHeadColumnTitle from "pages/Front/components/Tanstack/components/TableHeadColumnTitle";
import TableFilter from "pages/Front/components/Tanstack/components/Filters/TableFilter";
import TableBody from "pages/Front/components/Tanstack/components/TableBody";
import TableFoot from "pages/Front/components/Tanstack/components/TableFoot";
import TableFilterSellers from "pages/Front/Booking/Seller/components/Table/Filters/TableFilterSellers";

interface BookingSellerReservationsTableProps {
    tableInit: any;
    isTableStateSame?: boolean;
}

const BookingSellerReservationsTable = (props: BookingSellerReservationsTableProps) => {
    const allPersonsCount = props.tableInit.table.getRowModel().rows.reduce((acc, row) => acc + row.original.persons, 0);
    return (
        <TableWrapper className={"BookingSellerReservationsTable"}>
            <TableHeadWrapper>
                {props.tableInit.table.getHeaderGroups().map(headerGroup => (
                    <TableHeadRow key={headerGroup.id}>
                        {headerGroup.headers.map(header => {
                            return (
                                <TableHeadColumn key={header.id} colSpan={header.colSpan}>
                                    {header.isPlaceholder ? null : (
                                        <TableHeadColumnInnerWrapper className={clsx(header.id === "select" && "justify-center")}>
                                            <TableHeadColumnTitle
                                                className={clsx("leading-tight", header.id === "select" && "h-full", header.id === "actions" && "justify-end items-center h-full")}
                                                header={header}
                                                personsCount={allPersonsCount}
                                                tableInit={props.tableInit}
                                            />

                                            {header.column.getCanFilter() && header.id !== "seller_id" ? (
                                                <TableFilter column={header.column} table={props.tableInit.table} />
                                            ) : null}

                                            {header.column.getCanFilter() && header.id === "seller_id" ? (
                                                <TableFilterSellers column={header.column} table={props.tableInit.table} />
                                            ) : null}

                                        </TableHeadColumnInnerWrapper>
                                    )}
                                </TableHeadColumn>
                            );
                        })}
                    </TableHeadRow>
                ))}
            </TableHeadWrapper>
            <TableBody colSpan={12} decorationId={"no"} tableInit={props.tableInit} isTableStateSame={props.isTableStateSame} />
            <TableFoot colSpan={12} tableInit={props.tableInit} />
        </TableWrapper>
    );
};

export default BookingSellerReservationsTable;
